"use client"
import { Turnstile } from "@marsidev/react-turnstile"
import { useNonce } from "@/lib/nonce"

interface MathCaptchaProps {
  onVerified: (verified: boolean, token: string | null) => void
  // Fires when the widget itself errors (script blocked, challenge failed to
  // load) — distinct from an expired token — so callers can show guidance
  // instead of a silently dead checkbox.
  onLoadError?: () => void
}

export function MathCaptcha({ onVerified, onLoadError }: MathCaptchaProps) {
  const nonce = useNonce()

  return (
    <Turnstile
      siteKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!}
      options={{ theme: "dark" }}
      scriptOptions={nonce ? { nonce } : undefined}
      onSuccess={(token) => onVerified(true, token)}
      onExpire={() => onVerified(false, null)}
      onError={() => { onVerified(false, null); onLoadError?.() }}
    />
  )
}
